<!-- 支出 -->
<template>
    <div>
      <div class="expend">
        <div class="leftLine1">
          <p class="p1">订单类型</p>
          <div class="line"></div>
          <div class="rightBox">
            <div class="left">
              <div v-for="(item, index) in btnList" :key="index">
                <el-button
                  v-if="index !== 2"
                  @click="current1 = item"
                  class="btns1"
                  :class="current1 === item ? 'active' : ''"
                  size="small"
                  style="margin-right: 0.1rem"
                  plain
                  >{{ item }}</el-button
                >
                <el-select
                  class="select1"
                  style="width: 1.2rem; margin-right: 0.1rem"
                  size="small"
                  v-else
                  v-model="value"
                  placeholder="操作中(0)"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="right">
              <el-button class="btns1" size="small">重置</el-button>
              <el-button
                style="background-color: #db6e33; color: #fff"
                size="small"
                >搜索</el-button
              >
            </div>
          </div>
        </div>
        <div class="leftLine1">
          <p class="p1">查询关键词</p>
          <div style="height: 1rem" class="line"></div>
          <div class="rightBox1">
            <div style="display: flex; align-items: center; margin-bottom: 0.2rem">
              <el-input
                size="small"
                style="width: 1rem; margin-right: 0.1rem"
                placeholder="订单编号"
              ></el-input>
              <el-input
                size="small"
                style="width: 1rem; margin-right: 0.1rem"
                placeholder="团号"
              ></el-input>
              <el-input
                size="small"
                style="width: 1rem; margin-right: 0.1rem"
                placeholder="C端达人"
              ></el-input>
              <el-input
                size="small"
                style="width: 1rem; margin-right: 0.1rem"
                placeholder="新客"
              ></el-input>
              <el-input
                size="small"
                style="width: 1rem; margin-right: 0.1rem"
                placeholder="用户账号"
              ></el-input>
              <el-input
                size="small"
                style="width: 1.5rem; margin-right: 0.1rem"
                placeholder="下单企业名"
              ></el-input>
              <el-input
                size="small"
                style="width: 2rem; margin-right: 0.1rem"
                placeholder="请输入支付方交易单号"
              ></el-input>
              <el-date-picker
                size="small"
                style="margin-right: 0.1rem;width: 1.7rem;"
                v-model="value"
                type="date"
                placeholder="选择下单日期"
              >
              </el-date-picker>
              <el-date-picker
                style="margin-right: 0.1rem;width: 1.7rem;"
                size="small"
                v-model="value"
                type="date"
                placeholder="选择付款日期"
              >
              </el-date-picker>
            </div>
            <div style="display: flex; align-items: center">
              <p>金额：</p>
              <el-radio-group style="margin-right: 0.8px">
                <el-radio :label="3">
                  <span style="margin-right: 5px">大于等于</span>
                  <el-input
                    size="small"
                    style="width: 1rem; margin-right: 5px"
                    placeholder="请输金额"
                  ></el-input>
                  <span>¥</span>
                </el-radio>
                <el-radio :label="9">
                  <span style="margin-right: 5px">小于等于</span>
                  <el-input
                    size="small"
                    style="width: 1rem; margin-right: 5px"
                    placeholder="请输金额"
                  ></el-input>
                  <span>¥</span>
                </el-radio>
                <el-radio :label="6">
                  <el-input
                    size="small"
                    style="width: 1rem; margin-right: 5px"
                    placeholder="请输金额"
                  ></el-input>
                  <span>¥</span>
                  <span style="margin-right: 0.06rem">至</span>
                  <el-input
                    size="small"
                    style="width: 1rem; margin-right: 5px"
                    placeholder="请输金额"
                  ></el-input>
                  <span>¥</span>
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer">
        <div class="footTitle">
          <div class="footTitleLeft">
            <p class="p1">收款订单（我的收入）</p>
            <p class="p2">符合条件共：</p>
            <p class="p2">订单数（）</p>
            <p class="p2">收入总额（<span>¥</span>）</p>
          </div>
          <div class="footTitleRight">
            <el-button size="small" class="btns3" style="margin-right: 0.1rem"
              >开发票</el-button
            >
            <el-button size="small" class="btns3">导出</el-button>
          </div>
        </div>
        <div style="border: 1px solid #ebeef5">
          <el-table
            :header-cell-style="{ 
             backgroundColor:'#FDEFE7',color:'#000000'}"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column align="center" label="团号"> </el-table-column>
            <el-table-column align="center" label="订单编号"> </el-table-column>
            <el-table-column align="center" label="下单时间"> </el-table-column>
            <el-table-column align="center" label="支付方式"> </el-table-column>
            <el-table-column align="center" label="订单金额"> </el-table-column>
            <el-table-column align="center" label="操作"> </el-table-column>
          </el-table>
        </div>
        <Pagination></Pagination>
      </footer>
    </div>
  </template>
  
  <script>
  import Pagination from "@/components/Pagination.vue";
  export default {
    components: {
      Pagination,
    },
    data() {
      return {
        value: "",
        current1: "全部订单",
        tableData: [{}],
        btnList: ["全部订单", "待支付", "操作中", "已关闭"],
        options: [
          {
            value: "选项1",
            label: "待确认",
          },
          {
            value: "选项2",
            label: "待出行",
          },
          {
            value: "选项3",
            label: "待点评",
          },
          {
            value: "选项4",
            label: "交易完成",
          },
        ],
        options1: [
          {
            value: "选项1",
            label: "全部",
          },
          {
            value: "选项2",
            label: "PC端",
          },
          {
            value: "选项3",
            label: "小程序",
          },
        ],
      };
    },
    computed: {},
    watch: {},
    methods: {
      handleSelectionChange() {},
    },
    created() {},
    mounted() {},
  };
  </script>
  <style lang="scss" scoped>
  /deep/ .el-table th.el-table__cell .cell {
       color: #000 !important;
  }
  .active {
    background-color: #dc6d33 !important;
    color: #fff !important;
  }
  .expend {
    margin-bottom: 0.24rem;
    .leftLine1 {
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;
      .p1 {
        color: #db6e33;
        font-size: 0.12rem;
        font-family: SourceHanSansSC-bold;
        font-weight: bold;
        width: 0.65rem;
        text-align: right;
      }
      .line {
        height: 0.3rem;
        width: 1px;
        border-right: 1px solid var(--color);
        margin: 0 0.1rem;
      }
      .btns {
        background-color: #f7e1d3;
        color: #db6e33;
      }
      .btns1 {
        background-color: #fff;
        color: #db6e33;
        border: 1px solid #db6e33;
      }
      .rightBox {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .footer {
    .footTitle {
      height: 0.5rem;
      border: 1px solid #ebeef5;
      padding: 0 0.4rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: none;
      .footTitleLeft {
        display: flex;
        align-items: center;
        .p1 {
          margin-right: 0.2rem;
          font-size: 0.16rem;
          font-weight: bold;
          color: #000;
        }
        .p2 {
          font-size: 0.12rem;
          margin-right: 0.2rem;
          span {
            color: red;
          }
        }
      }
      .footTitleRight {
        .btns3 {
          background-color: #fff;
          color: #db6e33;
          border: 1px solid #db6e33;
        }
      }
    }
  }
  </style>
  